var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { TextAreaEmojiPicker, TextReplace } from "../Reactions";
import { EMOJI } from "../Reactions/constants";
var RichEditorWrapper = /** @class */ (function (_super) {
    __extends(RichEditorWrapper, _super);
    function RichEditorWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showFullEmojiPicker: false
        };
        _this.togglePickerModal = function () { return _this.setState(function (prevState) { return ({ showFullEmojiPicker: !prevState.showFullEmojiPicker }); }); };
        return _this;
    }
    RichEditorWrapper.prototype.render = function () {
        var _a = this.props, hasError = _a.hasError, inputRef = _a.inputRef, onChange = _a.onChange, textReplaceTypes = _a.textReplaceTypes, value = _a.value;
        var showFullEmojiPicker = this.state.showFullEmojiPicker;
        return (React.createElement(React.Fragment, null,
            textReplaceTypes.includes(EMOJI) && (React.createElement(TextAreaEmojiPicker, { cursorPosition: inputRef === null || inputRef === void 0 ? void 0 : inputRef.selectionStart, hasError: hasError, onChange: function (updatedValue) {
                    onChange(updatedValue);
                    return inputRef === null || inputRef === void 0 ? void 0 : inputRef.focus();
                }, showFullEmojiPicker: showFullEmojiPicker, togglePickerModal: this.togglePickerModal, value: value })),
            textReplaceTypes.map(function (t) { return (React.createElement(TextReplace, { cursorPosition: inputRef === null || inputRef === void 0 ? void 0 : inputRef.selectionStart, key: t, onChange: function (updatedValue) {
                    onChange(updatedValue);
                    return inputRef === null || inputRef === void 0 ? void 0 : inputRef.focus();
                }, showFullEmojiPicker: showFullEmojiPicker, type: t, value: value })); })));
    };
    return RichEditorWrapper;
}(Component));
export { RichEditorWrapper };
export default RichEditorWrapper;
